'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dProxy$002dName$0024$0024anon$002485 from "./presto.types$-Proxy-Name$$anon$85.js";
var $p;
/** @constructor */
function $c_Lpresto_types$ProxyName$() {
  this.c88 = null;
  this.c89 = false;
  this.c86 = null;
  this.c87 = false;
  this.c8c = null;
  this.c8d = false;
  this.c8a = null;
  this.c8b = false;
}
export { $c_Lpresto_types$ProxyName$ as $c_Lpresto_types$ProxyName$ };
$p = $c_Lpresto_types$ProxyName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$ProxyName$;
/** @constructor */
function $h_Lpresto_types$ProxyName$() {
}
export { $h_Lpresto_types$ProxyName$ as $h_Lpresto_types$ProxyName$ };
$h_Lpresto_types$ProxyName$.prototype = $p;
$p.crD = (function() {
  if ((!this.c89)) {
    this.c88 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c89 = true;
  }
  return this.c88;
});
$p.adi = (function() {
  if ((!this.c87)) {
    this.c86 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c87 = true;
  }
  return this.c86;
});
$p.crP = (function() {
  if ((!this.c8d)) {
    this.c8c = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c8d = true;
  }
  return this.c8c;
});
$p.cI0 = (function() {
  if ((!this.c8b)) {
    this.c8a = new $j_presto$002etypes$0024$002dProxy$002dName$0024$0024anon$002485.$c_Lpresto_types$ProxyName$$anon$85(this);
    this.c8b = true;
  }
  return this.c8a;
});
var $d_Lpresto_types$ProxyName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$ProxyName$, "presto.types$ProxyName$", ({
  a1f: 1,
  D: 1
}));
export { $d_Lpresto_types$ProxyName$ as $d_Lpresto_types$ProxyName$ };
var $n_Lpresto_types$ProxyName$;
function $m_Lpresto_types$ProxyName$() {
  if ((!$n_Lpresto_types$ProxyName$)) {
    $n_Lpresto_types$ProxyName$ = new $c_Lpresto_types$ProxyName$();
  }
  return $n_Lpresto_types$ProxyName$;
}
export { $m_Lpresto_types$ProxyName$ as $m_Lpresto_types$ProxyName$ };
//# sourceMappingURL=presto.types$-Proxy-Name$.js.map
